import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-tabs__link', function(e) {
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.js-tabs'),
				$links = $closest.find('.js-tabs__link'),
				$tabs = $closest.find('.js-tabs__fragment');

			$links.removeClass('is-active');
			$this.addClass('is-active');

			$tabs.removeClass('is-active');
			$tabs.filter( $this.attr('href') ).addClass('is-active');
		});

};
